import React from 'react';

const Loading = () => {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: '#2B2F3F',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      direction: 'rtl'
    }}>
      {/* Logo */}
      <div style={{ 
        marginBottom: '40px',
        animation: 'fadeInDown 0.6s ease-out'
      }}>
        <img 
          src="/Group 1000019470.png" 
          alt="Logo" 
          style={{
            width: '140px',
            height: 'auto',
            objectFit: 'contain',
            filter: 'drop-shadow(0px 4px 12px rgba(233, 106, 58, 0.3))'
          }}
        />
      </div>

      {/* Spinner Container */}
      <div style={{
        position: 'relative',
        width: '80px',
        height: '80px',
        marginBottom: '32px'
      }}>
        {/* Outer Ring */}
        <div style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          border: '4px solid rgba(233, 106, 58, 0.15)',
          borderTop: '4px solid #E96A3A',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }}></div>
        
        {/* Inner Ring */}
        <div style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '60%',
          height: '60%',
          border: '3px solid rgba(242, 125, 114, 0.2)',
          borderBottom: '3px solid #F27D72',
          borderRadius: '50%',
          animation: 'spin 0.8s linear infinite reverse'
        }}></div>
      </div>

      {/* Loading Text */}
      <p style={{
        fontFamily: 'Cairo, sans-serif',
        fontSize: '16px',
        color: 'rgba(249, 245, 240, 0.9)',
        fontWeight: 500,
        margin: 0,
        animation: 'pulse 1.5s ease-in-out infinite'
      }}>
        جاري التحميل...
      </p>

      {/* Dots Animation */}
      <div style={{
        marginTop: '16px',
        display: 'flex',
        gap: '8px'
      }}>
        {[0, 1, 2].map((i) => (
          <div
            key={i}
            style={{
              width: '8px',
              height: '8px',
              borderRadius: '50%',
              backgroundColor: '#E96A3A',
              animation: `bounce 1.4s ease-in-out ${i * 0.2}s infinite`
            }}
          />
        ))}
      </div>

      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        @keyframes pulse {
          0%, 100% { opacity: 0.9; }
          50% { opacity: 0.5; }
        }
        @keyframes bounce {
          0%, 80%, 100% { transform: translateY(0); }
          40% { transform: translateY(-12px); }
        }
        @keyframes fadeInDown {
          from {
            opacity: 0;
            transform: translateY(-30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default Loading;
